import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/ytd-mis-report';

function unwrap(body) {
  if (body?.success === false) {
    const msg = body?.message;
    throw new Error(typeof msg === 'string' ? msg : 'Request failed');
  }
  return body?.data ?? body;
}

const ytdMisReportService = {
  getData: async (reportDate) => {
    const response = await apiClient.get(`${BASE}/data`, {
      params: { report_date: reportDate },
    });
    const data = unwrap(response.data);
    return data?.report ?? null;
  },
};

export default ytdMisReportService;
